import { cdnOrigin } from '@maxpreps/network/src/origins';
import Sport from '@maxpreps/shared/constants/sportName';

interface IPrintableFormData {
  href: string;
  fileName: string;
}

const baseUrl = `${cdnOrigin}/includes/pdfs/stat_sheet`;
const statSheetCompare = `${Sport.Football},${Sport.Volleyball},${Sport.Soccer},${Sport.Basketball},${Sport.Baseball},${Sport.Softball},${Sport.Lacrosse}`;
/**
 * Get stat sheet urls.
 * @param sport
 * @param gender
 * @returns
 */
export const getStatSheet = (
  gender: 'Boys' | 'Girls' | 'Co-ed',
  sport: Sport
): IPrintableFormData | undefined => {
  if (statSheetCompare.indexOf(sport) === -1) {
    return undefined;
  }

  const formattedGenderSport =
    (sport === Sport.Lacrosse ? gender + '-' : '') + sport;

  return {
    href: `${baseUrl}/${formattedGenderSport}-stat-sheet.pdf`.toLowerCase(),
    fileName: `${formattedGenderSport}-Printable-Stat-Sheet.pdf`
  };
};

export const getShotChart = (sport: string): IPrintableFormData | undefined => {
  if ('Basketball'.indexOf(sport) === -1) {
    return undefined;
  }

  return {
    href: `${baseUrl}/${sport}-shot-chart.pdf`.toLowerCase(),
    fileName: `${sport}-Printable-Shot-Chart.pdf`
  };
};
